import { createSelector } from 'reselect';


export const DATA_KEY = 'next-videos';

export function getCursor(state) {
  return state.lazyVideoLists[DATA_KEY].nextVideosCursor;
}

export function getLoadedVideoIds(state) {
  return state.lazyVideoLists[DATA_KEY].videoIds;
}

export const getPrevVideoId = createSelector(
  getLoadedVideoIds,
  (state, videoId) => videoId,
  (ids, videoId) => {
    const index = ids.indexOf(videoId);
    if (index === -1) {
      return null;
    }

    return ids[index - 1] || null;
  }
);

export const getNextVideoId = createSelector(
  getLoadedVideoIds,
  (state, videoId) => videoId,
  (ids, videoId) => {
    const index = ids.indexOf(videoId);
    if (index === -1) {
      return null;
    }

    return ids[index + 1] || null;
  }
);



// WEBPACK FOOTER //
// ./src/widget/selectors/next-channel-videos.js